export const STORE_PROJECT_TEXT_BLOCKS = 'projectTextBlocksUI';
export type STORE_PROJECT_TEXT_BLOCKS = typeof STORE_PROJECT_TEXT_BLOCKS;
